var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m452 392h-6.258c3.445-14.574 5.258-29.654 5.258-45 0-107.523-87.477-195-195-195s-195 87.477-195 195c0 15.346 1.813 30.426 5.258 45h-6.258c-33.084 0-60 26.916-60 60s26.916 60 60 60h392c33.084 0 60-26.916 60-60s-26.916-60-60-60zm-196-210c90.981 0 165 74.019 165 165 0 53.913-26.133 104.043-70.121 135h-189.758c-43.988-30.957-70.121-81.087-70.121-135 0-90.981 74.019-165 165-165zm-226 270c0-16.542 13.458-30 30-30h15.968c9.227 22.165 22.512 42.524 39.295 60h-55.263c-16.542 0-30-13.458-30-30zm422 30h-55.263c16.783-17.476 30.068-37.835 39.295-60h15.968c16.542 0 30 13.458 30 30s-13.458 30-30 30z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 392c-8.271 0-15-6.729-15-15 0-8.284-6.716-15-15-15s-15 6.716-15 15c0 19.555 12.541 36.228 30 42.42v17.58c0 8.284 6.716 15 15 15s15-6.716 15-15v-17.58c17.459-6.192 30-22.865 30-42.42 0-24.813-20.187-45-45-45-8.271 0-15-6.729-15-15s6.729-15 15-15 15 6.729 15 15c0 8.284 6.716 15 15 15s15-6.716 15-15c0-19.555-12.541-36.228-30-42.42v-17.58c0-8.284-6.716-15-15-15s-15 6.716-15 15v17.58c-17.459 6.192-30 22.865-30 42.42 0 24.813 20.187 45 45 45 8.271 0 15 6.729 15 15s-6.729 15-15 15z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 120c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 8.284 6.716 15 15 15z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316 90c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 8.284 6.716 15 15 15z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196 90c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15s-15 6.716-15 15v60c0 8.284 6.716 15 15 15z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#f35a24"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.f26c90be33d4fef2aad5cd61111f4674.svg";
export { ForwardRef as ReactComponent };